
import './App.css';
import GanpatiPage from './Components/Home';
import Bhairavnath from './Components/History';
import SocialInitiatives from './Components/SamajikUpkram';
import Poster from './Components/Dekhava';
import GaneshGallery from './Components/Gallary';
import Donation from './Components/Nond';
import Contact from './Components/Contact';
import Footer from './Components/Footer';

function App() {
  return (
    <>
    <section id='home'>
   <GanpatiPage />
   </section>
   <section id='history'>
   <Bhairavnath />
   </section>
   <section id='samajik'>
   <SocialInitiatives/>
   </section>
   <Poster/>
   <section id='gallary'>
   <GaneshGallery/>
   </section>
   <section id='denagi'>
   <Donation/>
   </section>
   <section id='contact'>
   <Contact/>
   </section>
   <Footer/>
   </>
  );
}

export default App;
